import { render, staticRenderFns } from "./index.vue?vue&type=template&id=15b49782&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=15b49782&prod&scoped=true&lang=css"
import style1 from "@/styles/list.scss?vue&type=style&index=1&id=15b49782&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b49782",
  null
  
)

export default component.exports